import { useEffect } from 'react';

export function announceVisualReady(state: string): void {
  window.dispatchEvent(
    new CustomEvent('aztec-realms:visual-ready', {
      detail: { state },
    }),
  );
}

export function useVisualReady(state: string | undefined, ready: boolean): void {
  useEffect(() => {
    if (!state || !ready) return;
    let secondFrame = 0;
    const firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => announceVisualReady(state));
    });
    return () => {
      window.cancelAnimationFrame(firstFrame);
      if (secondFrame) window.cancelAnimationFrame(secondFrame);
    };
  }, [ready, state]);
}
